import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    targetContainer: { type: String, default: 'form-actions-container' }
  }

  change() {
    var element = document.getElementsByClassName('form-actions');
    if (element.length == 0)
    {
      this.newActionscontainer;
    }
  }

  get targetContainer() {
    return document.getElementsByName(this.targetContainerValue)[0]
  }

  get newActionscontainer() {
    var div = document.createElement("div");
    div.classList.add('form-actions','animate__animated', 'animate__bounceInUp')
    var button = document.createElement('button')
    var container = this.targetContainer;
    button.onclick = function(e) {
      container.querySelector('form:not(.no-js-submit)').submit();
    }
    button.classList.add('save');
    button.innerText = 'Save'
    div.appendChild(button);
    this.targetContainer.appendChild(div);
  }
}
